import { render, staticRenderFns } from "./products-viewer-swiper.vue?vue&type=template&id=49dc7cf0&"
import script from "./products-viewer-swiper.vue?vue&type=script&lang=js&"
export * from "./products-viewer-swiper.vue?vue&type=script&lang=js&"
import style0 from "./products-viewer-swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports